import { cn } from '@zep/utils';
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-[6px] bg-gray-200', className)} {...props} data-sentry-component="Skeleton" data-sentry-source-file="Skeleton.tsx" />;
}
export { Skeleton };